function currentCandidateRate(ctx) {
  const record = ctx.selectedRecords?.[0] ?? {};
  const rate = record.candidateRate ?? {};
  if (!rate.candidateAcceptedRate) return null;
  return {
    amount: rate.candidateAcceptedRate,
    symbol: rate.candidateAcceptedCurrencySymbol || '$',
    unit: rate.candidateAcceptedPayUnit,
  };
}

export const config = {
  title: 'Approve Rate',
  okText: 'Approve',
  width: 480,
  className: 'medium-modal',
  successMessage: 'Rate approved',
  getBodyText: (count, singularLabel, itemLabel, itemTitle, ctx) => {
    const rate = currentCandidateRate(ctx);
    return `Candidate Rate: ${rate ? `${rate.symbol}${rate.amount}/${rate.unit}` : '-'}`;
  },
  fields: [
    {
      name: 'candidateProposedRate',
      label: 'Proposed Rate',
      type: 'number',
      required: true,
      placeholder: 'Amount',
      min: 0,
      validator: (value, ctx) => {
        if (value === undefined || value === null || value === '') return undefined;
        const rate = currentCandidateRate(ctx);
        if (rate && Number(value) <= Number(rate.amount)) {
          return 'Proposed rate must be greater than Candidate Rate';
        }
        return undefined;
      },
    },
    {
      name: 'candidateProposedRateCurrency',
      label: 'Currency',
      type: 'select',
      required: true,
      defaultOptions: [
        { label: '$ USD', value: '$' },
        { label: '₹ INR', value: '₹' },
        { label: '€ EUR', value: '€' },
      ],
    },
    {
      name: 'candidateProposedRateUnit',
      label: 'Unit',
      type: 'select',
      required: true,
      defaultOptions: [
        { label: 'Year', value: 'yr' },
        { label: 'Month', value: 'mo' },
        { label: 'Week', value: 'wk' },
        { label: 'Hour', value: 'hr' },
        { label: 'Daily', value: 'day' },
      ],
    },
    {
      name: 'submitVia',
      label: 'Submit Via',
      type: 'radio',
      required: true,
      defaultOptions: [
        { label: 'Mail', value: 'Mail' },
        { label: 'VMS', value: 'VMS' },
      ],
    },
  ],
};
